export default "__VITE_ASSET__c65dfa68__"